import type React from 'react';
import { languageToLocaleMap } from 'src/components/common/TimeAgo/timeUtils';
import { format } from 'date-fns';
import type { EmployerLocale } from 'src/siteConfig';

interface Props {
  date: string;
  locale: EmployerLocale;
}

const DateFormat: React.FC<Props> = ({ date, locale }) => {
  try {
    const dateObject = new Date(date);

    return (
      <time dateTime={date}>
        {format(dateObject, 'dd MMM yyyy', {
          locale: languageToLocaleMap[locale],
        })}
      </time>
    );
  } catch (_e) {
    return null;
  }
};

export default DateFormat;
